<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GSIOAa/tc-custom/9781632657527.jpg?1718251155910" alt="This image is the cover for the book Management Productivity Multipliers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Management Productivity Multipliers
      </h1>
      <p class="bookDescription body article font2">
        <p>"This book provides a road map for establishing a high-performance culture and developing a pipeline of talent. This should be basic reading for all new managers." —Charles G. Tharp, executive vice president, HR Policy Association"Gerry Kraines is truly a global thought leader in the space of change management and aligning strategy." —Denis Turcotte, managing partner and COO, Private Equity Group, Brookfield Asset Management, Inc.Management Productivity Multipliers is your guide to being a better leader and to forging a stronger future in business.In his work consulting to major corporations for more than thirty years, Gerald Kraines consistently hears that 60–70 percent of business organizations' potential effectiveness goes unrealized. He shares how to engage, align, and develop employees in order to leverage and encourage optimal performance and long-lasting results.Filled with useful anecdotes and lively case studies, this book will help you increase your wisdom about colleagues, direct reports, and others, as well as yourself:•Develop powerful, yet straightforward strategies for leading people more effectively•Establish accountability leadership at every level of the organization that adds value•Define and implement managerial practices that will fully use people's potential•Drive organizational change and create a culture of adaptive readinessEliminate managerial abdication, bad hierarchy, and accountability gone awry in any organization. Business leaders who follow the principles in this book can multiply their chance of success and win back unrealized potential. Accountability, leadership, organizational alignment, and human resource systems are the building blocks for creating productive organizations. Kraines shares clear examples on how to get each of them right and properly integrated into a cohesive whole.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gerald Kraines
      </h2>
      
      <p class="authorDescription body article">Gerald Kraines, MD, was chairman and CEO of Levinson and Co. In 2019, the firm was acquired by Pariveda Solutions, where Dr. Kraines is now senior vice president, Strategic Organization Transformation. His clients have included Nestle, Verizon, AT&T, Coca Cola Femsa, Johnson & Johnson, The Gap, and Conoco Philips. Kraines received an undergraduate degree from Oberlin College and a postgraduate degree from Harvard Medical School.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Career Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f4a6b952